import { ready } from "@/lib/ready";
import { onceOptions } from "@/lib/onceOptions";
import { on } from "@/lib/dom/on";
import { hasClass } from "@/lib/dom/hasClass";
import { setWidth } from "@/lib/dom/setWidth";
import { setHeight } from "@/lib/dom/setHeight";
import { hideElement } from "@/lib/dom/hideElement";
import { lazyLoad } from "@/lib/lazyLoad";
import './styles/index.less'
import "@/share/global"
import "@/share/header"
import "@/share/footer"
import "./banner"
import { InitLazyCarousel, tryInitCarousel } from "./banner";
import { customerLeftMenuClient } from '@anypromo/shared/api/CustomerLeftMenuClient'

//导入share mvp
import "./shareMvp"
import Swiper, {Pagination, Navigation, Autoplay} from "swiper"
import 'swiper/swiper-bundle.min.css'
Swiper.use([Pagination, Navigation, Autoplay]);

ready(() => {
  /**
   * 
   */
  tryInitCarousel('#jcarousel-homepage-category-new', {
    autoStart: false,
    touch: true,
    // transitions: true,
    perPage: 2,
    responsive: {
      0: 2,
      450: 3,
      600: 3,
      750: 3,
      900: 3,
      1050: 5,
      1260: 6,
      1690: 7
    }
  })

  const renderRecentyItem = (item: any, index: Number) => {
    let review = '<div class="onsale_review">&nbsp;</div>'
    if (item.rating > 0) {

      let star = '';
      for (let i = 1; i <= 5; i++) {
        const diff = item.rating - i;
        const p = diff >= 0 ? 100 : (diff <= -1 ? 0 : ((diff + 1) * 100));
        star += `<span class="icon-review"><i class="icon-review-inner" style="width: ${p}%;"></i></span>`;
      }


      review = ` <div class="onsale_review">
  <span class="icon-review-box" title="${item.rating} of 5 stars">
  ${star}
  </span>
    <span class="review-score">${item.rating}</span>
</div>`;
    }
    return `<li class="promotion-item" data-pid="${item.productName}" data-name="${item.productName}" data-index="${index}" style="width: 225.25px;">
    <div class="jcarousel-product__box">
        <a class="jcarousel-product__image" href="${item.productLink}">
            <img src="${item.mediumImageUrl}" alt=" ${item.productName}" class="lazy7 promotion-item-click" width="300" height="300">
        </a>
       
        <a class="jcarousel-product__name promotion-item-click " href="${item.productLink}">
            ${item.productName}
        </a>
        ${review}
        <div class="jcarousel-product__info">
            as low as <em>${item.price}</em>
        </div>
    </div>
</li>`;
  }

  lazyLoad("#ltlRecently", () => {
    fetch('/Ajax/PageHeader.aspx?type=RecentlyView').then(r => r.json())
      .then((data: any[]) => {
        if (data.length == 0) {
          return;
        }


        document.querySelector('#ltlRecently')!.innerHTML = `<div class="jcarousel-product">
        <div class="container-title">Recently Viewed</div>
        <div class="jcarousel-wrapper"><div class="jcarousel" id="jcarousel-recently"><ul>`
          + data.map(renderRecentyItem).join('') + `</ul></div>` +
          '' + `
         <button type="button" class="jcarousel-control-prev visible-lg-block visible-md-block" aria-label="Previous"></button>
          <button type="button" class="jcarousel-control-next visible-lg-block visible-md-block" aria-label="Next"></button>
          <p class="jcarousel-pagination hidden-lg hidden-md"></p>
</div></div>`;

        tryInitCarousel("#jcarousel-recently", {
          autoStart: true,
          interval: 10000,
          pagination: true,
          touch: true,
          // transitions: true,
          responsive: {
            0: 2,
            500: 3,
            740: 4,
            980: 5,
          }
        })

      })

  })

  lazyLoad("embed[loading=lazy]", (el: HTMLElement) => {
    const embed = el as HTMLEmbedElement
    if (!embed.src) {
      embed.src = embed.dataset['src'] ?? ''
    }
  }, { unsupportedTimeout: 100 })



  if (document.querySelector("input.Is_Mobile")) {
    lazyLoadMobileContents()
  } else {
    tryInitCarousel("#jcarousel-testimonial", {
      lazy: true,
      autoStart: true,
      interval: 10000,
      pagination: true,
      touch: true,
      // transitions: true,
      responsive: {
        0: 2,
        768: 3,
        1500: 4,
      }
    })
  }

  // deal zone swiper init
  if (document.querySelector('#dealzoneSwiper')) {
    const swiper = new Swiper('#dealzoneSwiper .swiper-container', {
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      autoplay: {
          delay: 3000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
      },
      loopedSlides: 3,
      navigation: {
        nextEl: '#dealzoneSwiper .swiper-button-next',
        prevEl: '#dealzoneSwiper .swiper-button-prev',
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
    })
        // 添加鼠标事件监听器
    const slides = document.querySelectorAll('#dealzoneSwiper .swiper-slide');
    slides.forEach((slide, index) => {
      slide.addEventListener('mouseenter', () => {
        // 移除所有幻灯片的放大效果
        slides.forEach(s => s.classList.remove('swiper-slide-hover-zoom'));
        // 为当前悬停的幻灯片添加放大效果
        slide.classList.add('swiper-slide-hover-zoom');
      });
      slide.addEventListener('mouseleave', () => {
         // 鼠标离开时移除放大效果
         slide.classList.remove('swiper-slide-hover-zoom');
      });
    });
  }
});

function lazyLoadMobileContents () {

  lazyLoad("#ltlRecently", (el: HTMLElement) => {

    fetch("/Ajax/PageHeader.aspx?type=GetHomeGuide").then(data => data.text()).then(htmls => {
      const blocks = htmls.split("_|_")

      el.insertAdjacentHTML("beforebegin", blocks[0]);
      el.insertAdjacentHTML("afterend", blocks[1]);
      document.querySelector('.home-dealzone')!.insertAdjacentHTML("afterend", blocks[2]);

      lazyLoad(".lazy6,.lazy8", (el: HTMLElement) => {
        const img = el as HTMLImageElement
        img.src = img.dataset["original"] ?? ''
      })

      InitLazyCarousel()

      tryInitCarousel("#jcarousel-testimonial", {
        lazy: true,
        autoStart: true,
        interval: 10000,
        pagination: true,
        touch: true,
        // transitions: true,
        responsive: {
          0: 2,
          768: 3,
          1500: 4,
        }
      })

    })

  }, {
    unsupportedTimeout: 3000,
    observerConfig: {
      rootMargin: "0px 0px 50% 0px",
      threshold: 0
    }
  })
}

//promotionPopup
ready(() => {
  import("@/share/promotionPopup").then(f => {
    f.loadPromotionPopup()
  })
})
